export const FETCH_ERROR_FLAG_ID = 'fetchError';
